import { Component } from "../../../components/base/Component";
import { ComponentFactory } from "../../../services/ComponentFactory";
import { ICfa } from "../../../models/ICfa";

declare global {
	interface Window {
		dataLayer: any[];
	}
}

export class StillHaveQuestion extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		this.applyDatalayerEvent();
	}

	private applyDatalayerEvent(): void {
		const datalayerButtons =
			this._element.querySelectorAll<HTMLElement>("[data-datalayer]");

		if (datalayerButtons.length > 0) {
			datalayerButtons.forEach((button: HTMLElement) => {
				if (button.tagName.toLowerCase() === "a") {
					button.addEventListener("click", e => {
						e.preventDefault();
						const href = (button as HTMLAnchorElement).href;
						if (!href) return;

						const event = {
							event: "content_click",
							module_name: "cares_form",
							page_url: window.location.href,
							link_category: "click_to_call",
							link_text: button.innerText,
							link_url: href,
							method: "text_link",
							eventCallback: () => {
								window.location.href = href;
							},
							eventTimeout: 1000
						};

						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push(event);

						// As a fallback, in case GTM doesn't call the callback
						setTimeout(() => {
							window.location.href = href;
						}, 1100);
					});
				} else {
					console.log("Button is not an anchor tag, skipping click event.");
				}
			});
		}
	}
}

ComponentFactory.registerComponent("StillHaveQuestion", StillHaveQuestion);
